import React, { useMemo } from "react";

export const CheckAllBoxType = {
  None: "NONE",
  All: "ALL",
  Some: "SOME",
} as const;

export type CheckAllBoxType = (typeof CheckAllBoxType)[keyof typeof CheckAllBoxType];

const CheckAllBox = ({ style, onClick }: { style: CheckAllBoxType; onClick: () => void }) => {
  const insidePic = useMemo(() => {
    switch (style) {
      case "ALL":
        return <img src="/svg/check.svg" className="h-4.5 w-4.5" alt="CheckAll" />;
      case "SOME":
        return <img src="/svg/line.svg" className="h-4 w-4" alt="CheckAll" />;
      case "NONE":
        return null;
    }
  }, [style]);

  return (
    <div className="flex w-fit cursor-pointer items-center gap-2.5" onClick={onClick}>
      <div
        className={`flex h-6 w-6 items-center justify-center rounded-[3px] ${style === CheckAllBoxType.None ? "border border-form-border bg-form-background hover:border-text-black" : "bg-primary hover:bg-link-dark"}`}
      >
        {insidePic}
      </div>
      <span className="text-s leading-normal">すべて選択</span>
    </div>
  );
};

export default CheckAllBox;
